import { gql_request, GqlRequestOptions } from '@common/api-request';

import * as types from './request-ai-edit_types.2';

export function requestAiImageEdit(variable: types.RequestAiImageEditVariables, options?: GqlRequestOptions) {
  const query = 'mutation RequestAiImageEdit($catalog_product_id: ID!, $shop_id: Int!) { ux_request_ai_image_edit(catalog_product_id: $catalog_product_id, shop_id: $shop_id) { is_size_hidden } }';
  return gql_request<types.RequestAiImageEdit, types.RequestAiImageEditVariables>('RequestAiImageEdit', query, variable, { use_consumer: true, ...options });
}

